import { InjectionToken } from '@angular/core';

export const FEATURE_FLAG_PROVIDER = new InjectionToken<IFeatureFlagProvider>('FeatureFlagProvider');

export interface IFeatureFlagProvider {
  /**
   * Initialize the provider (e.g., fetch flags from remote)
   */
  init(): Promise<void>;

  /**
   * Get the value of a specific flag
   */
  getValue(key: string): boolean;
}
